@if (billAccount) {
  <div class="main row">
    <div class="row">
      <div class="column twelve">
        <div>
          <h2 class="margin-bottom-20" [innerHTML]="registerAccountCopy"></h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="column twelve">
        <p dsContent [contentPath]="'billing.registerAccountText'"></p>
        @if (acceptTerms) {
          <form [formGroup]="billAccountTermsForm" class="margin-top-30">
            <input
              authCheck
              [permissionName]="'registerbillacct_submit_disable'"
              [checkAction]="'disable'"
              type="checkbox"
              class="checkbox"
              id="billingTermsAgree"
              formControlName="billingTermsAgree"
              data-cy="billingTermsAgree"
            />
            <label for="billingTermsAgree" class="checkbox-label">
              <p>
                I have read and agree to the
                <a
                  [dsRouterLink]="['/terms/billing']"
                  dsContent
                  [contentPath]="'billing.billingTermsAndCondition'"
                ></a>
              </p>
            </label>
          </form>
        }
      </div>
    </div>
    <div class="row">
      <hr aria-hidden="true" class="column twelve" />
    </div>
    <div class="row">
      <div class="column twelve">
        <h2 class="margin-bottom-20">
          Complete Registration of {{ billAccount.billAccountNumber | prettyBillingAcctNum }}
          {{ optionalCount }}
        </h2>
      </div>
    </div>
    @if (registrationError === true && errorList?.length) {
      <ds-error-message [errorList]="errorList"></ds-error-message>
    }
    @if (hasAdvancedPolicy) {
      <div class="row">
        <div class="column twelve">
          <p
            class="margin-bottom-20"
            dsContent
            [contentPath]="'billing.paymentMethodSelectTxt'"
          ></p>
        </div>
      </div>
    }
    <div class="row account-info">
      <div class="column twelve lg-six pad-bottom-20">
        <p class="account-info-title" dsContent [contentPath]="'shared.accountNumber'"></p>
        <p>{{ billAccount.billAccountNumber | prettyBillingAcctNum }}</p>
      </div>
      @if (!!riskDescriptionArr.length) {
        <div class="column twelve lg-six pad-bottom-20">
          <p class="account-info-title" dsContent [contentPath]="'billing.riskDescription'"></p>
          @for (risk of riskDescriptionArr; track risk; let i = $index) {
            <div>
              <div>
                <p>{{ risk | prettyRiskDescription }}</p>
              </div>
            </div>
          }
        </div>
      }
    </div>
    <div class="row">
      <div class="column twelve">
        <p
          class="account-info-title"
          dsContent
          [contentPath]="'billing.nameYourBillingAccount'"
        ></p>
        <p class="pad-bottom-30" dsContent [contentPath]="'billing.nameYourBillingAccountText'"></p>
      </div>
    </div>
    <form [formGroup]="billAccountRegisterForm">
      <div class="row">
        <div class="column twelve md-three">
          <div class="md-pad-right-10">
            <ds-form-control-container
              [labelText]="'Billing Account Name'"
              [control]="billAccountRegisterForm.controls['accountName']"
            >
              <input id="accountName" class="fill" formControlName="accountName" maxlength="25" />
              <ds-form-control-message [control]="billAccountRegisterForm.controls['accountName']">
              </ds-form-control-message>
            </ds-form-control-container>
          </div>
        </div>
        <div class="column twelve md-four">
          <div class="md-pad-left-10">
            <ds-form-control-container
              [labelText]="'Email Reminder'"
              [control]="billAccountRegisterForm.controls['reminder']"
            >
              <select id="reminder" class="icon fill" formControlName="reminder">
                @for (day of [7, 6, 5, 4, 3]; track day) {
                  <option [value]="day">
                    {{ day }}
                    @if (day >= 3 && day < 8) {
                      <span dsContent [contentPath]="'billing.dueDateAdditionalText'"></span>
                    }
                  </option>
                }
                <option value="No Reminder" dsContent [contentPath]="'billing.noReminder'"></option>
              </select>
              <span class="icon-chevron-down"></span>
              <ds-form-control-message
                [control]="billAccountRegisterForm.controls['reminder']"
              ></ds-form-control-message>
            </ds-form-control-container>
          </div>
        </div>
      </div>
      <div>
        <div class="pad-top-10">
          <div class="column twelve md-six">
            <ul class="criteria-list">
              <li
                [ngClass]="
                  accountName.hasError('invalidNickName') || accountName.value.length === 0
                    ? 'hasError'
                    : 'isValid'
                "
                class="pseudo-icon"
              >
                Letters, numbers and spaces only
              </li>
              <li
                [ngClass]="
                  accountName.hasError('noMoreThanFourNumbers') || accountName.value.length === 0
                    ? 'hasError'
                    : 'isValid'
                "
                class="pseudo-icon"
              >
                Max 4 numbers
              </li>
              <li
                [ngClass]="
                  billAccountRegisterForm.hasError('duplicateNickName') ||
                  accountName.value.length === 0
                    ? 'hasError'
                    : 'isValid'
                "
                class="pseudo-icon"
              >
                Cannot be repeated
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <hr aria-hidden="true" class="column twelve" />
        <div class="column twelve">
          <p>
            <span dsContent [contentPath]="'billing.updateYourEmailText'"></span>
            {{ emailAddress }}.
            <span dsContent [contentPath]="'billing.updateYourEmailTextAfter'"></span>
          </p>
        </div>
      </div>
      <div class="row flex items-center pad-top-20">
        <div class="column">
          <button
            ds-button
            class="save-btn"
            data-cy="saveButton"
            type="submit"
            [disabled]="
              !billAccountRegisterForm.valid ||
              !billAccountTermsForm.controls['billingTermsAgree'].value ||
              (updatingRegistration | async) ||
              (roleService.isAuthorized('registerbillacct_submit_disable') | async) === false
            "
            (click)="registerBillAccount(billAccountRegisterForm.value)"
          >
            <span
              [attr.aria-label]="count > 1 ? saveAndContinueBtnContent : saveBtnContent"
              [innerText]="count > 1 ? saveAndContinueBtnContent : saveBtnContent"
            ></span>
          </button>
        </div>
        <div class="column cancel-reg">
          <a
            class="caption no-decoration"
            [dsRouterLink]="[billingPaths.BILLING_SECTION_PAGE]"
            dsContent
            [contentPath]="'shared.cancelSignUp'"
          ></a>
        </div>
      </div>
    </form>
  </div>
}
